<script>
import { VTextField } from 'vuetify/lib';

export default {
  functional: true,
  render(h, { data }) {
    return h(VTextField, {
      ...data,
      class: [data.class, data.staticClass],
      style: [data.style, data.staticStyle],
      attrs: {
        ...data.attrs,
        type: 'number',
        value: Number.parseInt(data.attrs.value),
      },
    });
  },
};
</script>
